import { render, staticRenderFns } from "./CompaniesTariffList.vue?vue&type=template&id=6fc6afd2&scoped=true&"
import script from "./CompaniesTariffList.vue?vue&type=script&lang=js&"
export * from "./CompaniesTariffList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc6afd2",
  null
  
)

export default component.exports